import React from 'react'
import {
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect
      selector={[
        dispatch.restaurant.getAddress,
        dispatch.restaurant.getFormattedPhoneNumber,
        dispatch.restaurant.getEmail,
      ]}
    >
      {([address, phoneNumber, email, locationId]) => (
        <CFView>
          <MobileScreen>
            <CFView column justifyStart mb="20px">
              <CFView h6 helvetica color="#666666" pb="20px">
                contact
              </CFView>
              <CFView h6 helvetica color="#666666" pb="5px">
                #102 - 2201 holdom avenue
              </CFView>
              <CFView h6 helvetica color="#666666" pb="20px">
                burnaby bc v5b 0a2
              </CFView>
              <CFView h6 helvetica color="#666666" pb="30px">
                604-293-2201
              </CFView>
              <CFView h6 helvetica color="#666666" pb="30px">
                instagram.com/sushimoto_enterprises
              </CFView>
              <CFView h6 helvetica color="#666666" pb="200px">
                burnaby, bc
              </CFView>
              {/* <CFView h6 helvetica color="#666666" mb="20px">
                contact
              </CFView>
              <CFView column center>
                {address && (
                  <CFView row w="100%" mb="1rem">
                    <CFView w="9rem">
                      <CFView heading h6 color="#666666" helvetica>
                        Address
                      </CFView>
                    </CFView>
                    <CFLink href="https://maps.app.goo.gl/9QRVLz6EvBvsRfB38">
                      <CFView
                        heading
                        h6
                        color="#666666"
                        helvetica
                        maxWidth="200px"
                      >
                        {address}
                      </CFView>
                    </CFLink>
                  </CFView>
                )}
                {phoneNumber && (
                  <CFView row w="100%" mb="10px">
                    <CFView w="9rem">
                      <CFView heading h6 color="#666666" helvetica>
                        Phone
                      </CFView>
                    </CFView>
                    <CFView heading h6 color="#666666" helvetica>
                      {phoneNumber}
                    </CFView>
                  </CFView>
                )}
                {email && (
                  <CFView row w="100%">
                    <CFView w="9rem">
                      <CFView heading h6 color="#666666" helvetica>
                        Email
                      </CFView>
                    </CFView>
                    <CFView heading h6 color="#666666" helvetica>
                      {email}
                    </CFView>
                  </CFView>
                )}
              </CFView> */}
            </CFView>
          </MobileScreen>
          <DefaultScreen>
            <CFView mr="15px">
              <CFView h6 helvetica color="#666666" pb="20px">
                contact
              </CFView>
              <CFView h6 helvetica color="#666666" pb="5px">
                #102 - 2201 holdom avenue
              </CFView>
              <CFView h6 helvetica color="#666666" pb="20px">
                burnaby bc v5b 0a2
              </CFView>
              <CFView h6 helvetica color="#666666" pb="30px">
                604-293-2201
              </CFView>
              <CFView h6 helvetica color="#666666" pb="30px">
                instagram.com/sushimoto_enterprises
              </CFView>
              <CFView h6 helvetica color="#666666" pb="200px">
                burnaby, bc
              </CFView>
              {/* <CFView column center>
                {address && (
                  <CFView row w="100%" mb="1rem">
                    <CFView w="9rem">
                      <CFView heading h6 color="#666666" helvetica>
                        Address
                      </CFView>
                    </CFView>
                    <CFLink href="https://maps.app.goo.gl/9QRVLz6EvBvsRfB38">
                      <CFView
                        heading
                        h6
                        color="#666666"
                        helvetica
                        maxWidth="210px"
                      >
                        {address}
                      </CFView>
                    </CFLink>
                  </CFView>
                )}
                {phoneNumber && (
                  <CFView row w="100%" mb="10px">
                    <CFView w="9rem">
                      <CFView heading h6 color="#666666" helvetica>
                        Phone
                      </CFView>
                    </CFView>
                    <CFView heading h6 color="#666666" helvetica>
                      {phoneNumber}
                    </CFView>
                  </CFView>
                )}
                {email && (
                  <CFView row w="100%" mb="10px">
                    <CFView w="9rem">
                      <CFView heading h6 color="#666666" helvetica>
                        Email
                      </CFView>
                    </CFView>
                    <CFLink href={`mailto:${email}`}>
                      <CFView heading h6 color="#666666" helvetica>
                        {email}
                      </CFView>
                    </CFLink>
                  </CFView>
                )}
              </CFView> */}
            </CFView>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
